window.formatCurrency = function(n) {
    var c = 2;
    var d = '.';
    var t = ',';
    var s = n < 0 ? '-' : '';
    var i = String(parseInt((n = Math.abs(Number(n) || 0).toFixed(c))));
    var j = (j = i.length) > 3 ? j % 3 : 0;
    return (
        s +
        (j ? i.substr(0, j) + t : '') +
        i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + t) +
        (c
            ? d +
              Math.abs(n - i)
                  .toFixed(c)
                  .slice(2)
            : '')
    );
};

(function($) {
    $(document).ready(function() {
        var recordsPerPage = 20;

        //bootstrap multiple modal bugfix
        $('.modal').on('shown.bs.modal', function() {
            $('body').addClass('modal-open');
        });

        if ($('.landfinder #grid').length) {
            var dataSource = new kendo.data.DataSource({
                transport: {
                    dataType: 'json',
                    read: '/home/json'
                },
                schema: {
                    data: 'data',
                    total: 'total',
                    model: {
                        fields: {
                            Size: { type: 'number' },
                            CurrentPrice: { type: 'number' }
                        }
                    }
                },
                pageSize: recordsPerPage,
                serverPaging: true,
                serverSorting: true,
                serverFiltering: true
            });

            $('#grid').kendoGrid({
                dataSource: dataSource,
                groupable: false,
                sortable: true,
                pageable: {
                    refresh: true,
                    pageSizes: false,
                    buttonCount: 10
                },
                columns: [
                    {
                        field: 'Suburb',
                        width: '170px'
                    },
                    {
                        field: 'Estate',
                        width: '170px'
                    },
                    {
                        field: 'Region',
                        title: 'Corridor',
                        width: '150px'
                    },
                    {
                        field: 'Developer',
                        width: '125px'
                    },
                    {
                        field: 'Stage',
                        width: '75px'
                    },
                    {
                        field: 'LotNumber',
                        title: 'Lot #',
                        width: '75px'
                    },
                    {
                        field: 'Size',
                        width: '75px'
                    },
                    {
                        field: 'Frontage',
                        width: '100px'
                    },
                    {
                        field: 'CurrentPrice',
                        title: 'Price',
                        template: '$#: window.formatCurrency(data.CurrentPrice) #',
                        width: '150px'
                    },
                    {
                        field: 'Status',
                        title: 'Availability',
                        width: '100px'
                    },
                    {
                        field: 'Details',
                        title: 'Siteworks Details',
                        template:
                            '<a href="/home/details/#:escape(data.Estate)#" class="btn view-details">View Costs</a>',
                        filterable: false,
                        width: '150px'
                    }
                ]
            });
        }

        $('.landfinder .filter-panel form').on('submit', function(e) {
            e.preventDefault();

            var grid = $('#grid').data('kendoGrid');
            var filterList = [];

            $(this)
                .find('input')
                .each(function(i, f) {
                    var jqueryField = $(f);
                    var fieldValue = '';

                    switch (jqueryField.attr('type')) {
                        case 'checkbox':
                            fieldValue = jqueryField.prop('checked') ? jqueryField.val() : '';
                            break;
                        default:
                            fieldValue = jqueryField.val();
                            break;
                    }

                    if (fieldValue !== '') {
                        filterList.push({
                            field: jqueryField.data('field'),
                            operator: jqueryField.data('operator'),
                            value: fieldValue
                        });
                    }
                });

            grid.dataSource.query({
                page: 1,
                pageSize: recordsPerPage,
                filter: {
                    logic: 'or',
                    filters: filterList
                }
            });
        });

        $('body').delegate('.view-details', 'click', function(e) {
            e.preventDefault();
            $('#terms-modal')
                .data('url', $(this).attr('href'))
                .modal('show');
        });

        $('#terms-modal-accept').on('click', function(e) {
            e.preventDefault();
            $('#terms-modal').modal('hide');

            $.ajax({
                url: $('#terms-modal').data('url'),
                method: 'GET',
                dataType: 'html'
            }).done(function(response) {
                $('#details-modal-body').html(response);
                $('#details-modal').modal('show');
            });
        });
    });
})(jQuery);
